function normalizePermList(requiredPerms) {
  if (Array.isArray(requiredPerms)) {
    return requiredPerms.filter(Boolean);
  }
  if (typeof requiredPerms === 'string' && requiredPerms.trim()) {
    return [requiredPerms.trim()];
  }
  return [];
}

function visitMenus(nodes, visitor) {
  if (!Array.isArray(nodes) || !visitor) {
    return;
  }
  nodes.forEach((node) => {
    if (!node) {
      return;
    }
    visitor(node);
    if (Array.isArray(node.children) && node.children.length > 0) {
      visitMenus(node.children, visitor);
    }
  });
}

function resolveRootVm(vm) {
  if (!vm) {
    return null;
  }
  return vm.$root || vm;
}

function getCurrentUser(vm) {
  const rootVm = resolveRootVm(vm);
  if (rootVm && rootVm.currentUser) {
    return rootVm.currentUser;
  }
  if (rootVm && rootVm.$children && rootVm.$children[0] && rootVm.$children[0].currentUser) {
    return rootVm.$children[0].currentUser;
  }
  return null;
}

export function isAdminUser(vm) {
  const user = getCurrentUser(vm);
  if (!user) {
    return false;
  }
  const ia = user.isAdmin;
  if (ia === 1 || ia === true || ia === '1') {
    return true;
  }
  return Array.isArray(user.roleCodes) && user.roleCodes.indexOf('admin') !== -1;
}

/** 超级管理员（与后端 SysDataScopeService.isSuperAdmin 一致：userId=1），用于部门↔投放映射等高危操作 */
export function isSuperAdminUser(vm) {
  const user = getCurrentUser(vm);
  if (!user || user.id === undefined || user.id === null) {
    return false;
  }
  return Number(user.id) === 1;
}

export function hasRoleCode(vm, roleCode) {
  if (!roleCode) {
    return false;
  }
  const user = getCurrentUser(vm);
  return !!(user && Array.isArray(user.roleCodes) && user.roleCodes.indexOf(roleCode) !== -1);
}

export function collectGrantedPerms(vm) {
  const perms = new Set();
  const user = getCurrentUser(vm);
  // 后端 /system/auth/me 返回的扁平权限（与菜单树嵌套无关，分销等非管理员可靠依赖此项）
  if (user && Array.isArray(user.grantedPerms) && user.grantedPerms.length > 0) {
    user.grantedPerms.forEach((p) => {
      if (p) perms.add(p);
    });
    return perms;
  }
  const rootVm = resolveRootVm(vm);
  if (!rootVm || !Array.isArray(rootVm.menuTree)) {
    return perms;
  }
  visitMenus(rootVm.menuTree, (node) => {
    if (node.perms) {
      perms.add(node.perms);
    }
  });
  return perms;
}

export function hasAnyPermission(vm, requiredPerms) {
  const normalizedPerms = normalizePermList(requiredPerms);
  if (normalizedPerms.length === 0) {
    return true;
  }
  if (isAdminUser(vm)) {
    return true;
  }
  const grantedPerms = collectGrantedPerms(vm);
  return normalizedPerms.some((perm) => grantedPerms.has(perm));
}

export function hasAllPermissions(vm, requiredPerms) {
  const normalizedPerms = normalizePermList(requiredPerms);
  if (normalizedPerms.length === 0) {
    return true;
  }
  if (isAdminUser(vm)) {
    return true;
  }
  const grantedPerms = collectGrantedPerms(vm);
  return normalizedPerms.every((perm) => grantedPerms.has(perm));
}
